import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import BJLogo from '../../../Assets/Images/BJ.png';
import '../../Membership/Membership.css';
import {  useNavigate, useSearchParams } from "react-router-dom";
import { AuthService } from "../../../Services/Axios/Api";

const ResetPassword = () => {
    const { t } = useTranslation();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const email = searchParams.get('email');
    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');
        setSuccess('');
        if (!password || !confirmPassword) {
            setError(t('ResetPassword.Validation.BothFieldsRequired'));
            return;
        }
        if (password.length < 6) {
            setError(t('ResetPassword.Validation.PasswordLength'));
            return;
        }
        if (password !== confirmPassword) {
            setError(t('ResetPassword.Validation.PasswordsDoNotMatch'));
            return;
        }
        setIsLoading(true);
        try {
            const response = await AuthService.ResetPassword(token, email, password);
            if (response.isSuccess) {
                setSuccess(t('ResetPassword.Success'));
                
            } else {
                setError(response.errorMessage);
            }   
        } catch (error) {
            setError(error.response?.data?.errorMessages?.[0] || 'Failed to reset password');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
            <Row className="justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                <Col md={12} lg={12}>
                    <Card className="membership-card p-4">
                        <Card.Body>
                            <div className="text-center mb-4">
                                <h2 className="membership-title">{t('ResetPassword.Title')}</h2>
                                <p className="membership-subtitle">{t('ResetPassword.Subtitle')}</p>
                            </div>
                            {error && <Alert variant="danger">{error}</Alert>}
                            {success && <Alert variant="success">{success}</Alert>}
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('ResetPassword.NewPasswordLabel')}</Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder={t('ResetPassword.NewPasswordPlaceholder')}
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        isInvalid={!!error && !success}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('ResetPassword.ConfirmPasswordLabel')}</Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder={t('ResetPassword.ConfirmPasswordPlaceholder')}
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        isInvalid={!!error && !success}
                                    />
                                </Form.Group>
                                <Button type="submit" className="w-100 submit-button" disabled={isLoading}>
                                    {isLoading ? (
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                                    ) : null}
                                    {t('ResetPassword.SubmitButton')}
                                </Button>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default ResetPassword; 